import { render } from "./GenerateGroups.vue?vue&type=template&id=423e543f&scoped=true"
import script from "./GenerateGroups.vue?vue&type=script&lang=js"
export * from "./GenerateGroups.vue?vue&type=script&lang=js"

import "./GenerateGroups.vue?vue&type=style&index=0&id=423e543f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423e543f"]])

export default __exports__